import axios from 'axios'

export const ConfigSystemApi = { 
    list: () => axios.get('/web/config-system/'),
    toggleConfig: (configSystemId, enabled) => axios.put(`/web/config-system/${configSystemId}/toggle/`, { enabled }),
    updateConfig: (id, title, configType, configValue, enabled, param) => axios.put(`/web/config-system/${id}/update/`, { id, title, configType, configValue, enabled, param }),
}
